export default __webpack_public_path__ + "static/media/saytspb.391d7d26.jpeg";